import { ContratanteService } from '@elotech/painel/src/service';
import React, { createContext, useCallback, useEffect, useState } from 'react';

type Props = {};

type ContratanteContext = {
  emailContratante: string;
  emailElotech: string;
  isUsuarioTecnico: (email: string) => boolean;
};

const initialContext = {
  emailContratante: '',
  emailElotech: '@elotech.com.br',
  isUsuarioTecnico: (email: string) => false
};

export const ContratanteContext = createContext<ContratanteContext>(
  initialContext
);

const ContratanteProvider: React.FC<Props> = ({ children }) => {
  const [emailContratante, setEmailContratante] = useState('');

  const isUsuarioTecnico = useCallback(
    (email: string): boolean => {
      if (email.includes(initialContext.emailElotech)) return true;

      if (!emailContratante) return false;

      return Boolean(email.match(emailContratante));
    },
    [emailContratante]
  );

  useEffect(() => {
    ContratanteService.findEmailDomain().then(({ data }) =>
      setEmailContratante(data)
    );
  }, []);

  return (
    <ContratanteContext.Provider
      value={{ ...initialContext, emailContratante, isUsuarioTecnico }}
    >
      {children}
    </ContratanteContext.Provider>
  );
};

export default ContratanteProvider;
